import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  visible: false,
  listTemplate: [],
  activeTemplate: {},
  isLoadingListRecord: false,
  listRecord: [],
  listQuotationItem: [],
  idClear: "",
  optionEdit: "",
  quotationHistory: [],
  contentTemplate: "",
  isDelete: 0,
  isCreate: 0,
  idReloadListQuotation: "",
  idReload: "",
  listIDCreate: [],
  listSaleOrderItem: [],
  isReloadComponent: "",
};

const slice = createSlice({
  name: "quotation",
  initialState,
  reducers: {
    setIsReloadComponent(state, action) {
      state.isReloadComponent = action.payload;
    },
    setIsLoadingListRecord(state, action) {
      state.isLoadingListRecord = action.payload;
    },
    updateVisibleQuotation(state, action) {
      state.visible = action.payload;
    },
    getListQuotationTemplate() {},
    getListQuotationTemplateSuccess(state, action) {
      state.listTemplate = action.payload;
    },
    createQuotationTemplate() {},
    updateQuotationTemplate() {},
    toggleQuotationTemPlate() {},
    defaultQuotationTemplate() {},
    updateActiveTemplate(state, action) {
      state.activeTemplate = action.payload;
    },
    deleteQuotationTemplate() {},
    createRecord() {},
    updateRecord() {},
    deleteQuotation() {},
    getListRecord(state) {
      state.isLoadingListRecord = true;
    },
    getListRecordSuccess(state, action) {
      state.listRecord = action.payload;
      state.isLoadingListRecord = false;
    },
    getListQuotationItem() {},
    getListQuotationItemSuccess(state, action) {
      state.listQuotationItem = action.payload;
    },
    getListSaleOrderItemSuccess(state, action) {
      state.listSaleOrderItem = action.payload;
    },
    createQuotationItem() {},
    updateQuotationItem() {},
    deleteQuotationItem() {},
    updateIdClear(state, action) {
      state.idClear = action.payload;
    },
    updateIdReload(state, action) {
      state.idReload = action.payload;
    },
    updatePositionQuotationItem() {},
    updateOptionEdit(state, action) {
      state.optionEdit = action.payload;
    },
    getQuotationHistory() {},
    getQuotationHistorySuccess(state, action) {
      state.quotationHistory = action.payload;
    },
    renderTemplate() {},
    renderTemplateSuccess(state, action) {
      state.contentTemplate = action.payload;
    },
    updateIsDelete(state, action) {
      state.isDelete = action.payload;
    },
    updateIsCreate(state, action) {
      state.isCreate = action.payload;
    },
    updateIdReloadListQuotation(state, action) {
      state.idReloadListQuotation = action.payload;
    },
    updateListIDCreate(state, action) {
      if (action.payload) {
        state.listIDCreate = [...state.listIDCreate, action.payload];
      } else {
        state.listIDCreate = [];
      }
    },
  },
});

export default slice.reducer;

export const {
  setIsReloadComponent,
  setIsLoadingListRecord,
  updateVisibleQuotation,
  getListQuotationTemplate,
  getListQuotationTemplateSuccess,
  createQuotationTemplate,
  toggleQuotationTemPlate,
  defaultQuotationTemplate,
  updateActiveTemplate,
  updateQuotationTemplate,
  deleteQuotationTemplate,
  createRecord,
  updateRecord,
  deleteQuotation,
  getListRecord,
  getListRecordSuccess,
  getListQuotationItem,
  getListQuotationItemSuccess,
  getListSaleOrderItemSuccess,
  createQuotationItem,
  updateQuotationItem,
  deleteQuotationItem,
  updateIdClear,
  updateIdReload,
  updatePositionQuotationItem,
  updateOptionEdit,
  getQuotationHistory,
  getQuotationHistorySuccess,
  renderTemplate,
  renderTemplateSuccess,
  updateIsDelete,
  updateIsCreate,
  updateIdReloadListQuotation,
  updateListIDCreate,
} = slice.actions;
